import {
  withStyles,
  WithStyles,
  Typography,
  Theme,
  Fab,
  Link,
  Grid,
  CircularProgress
  // Tooltip,
} from '@material-ui/core'
import i18n from 'i18next'
import { FC, Fragment, useState, useEffect, useRef } from 'react'
import { withTranslation, WithTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import { Dispatch } from 'redux'
import Talk from 'talkjs'
import {
  selectApplications,
  rejectApplication
} from '../../actions/applications'
import { closeDialog, openDialog } from '../../actions/dialogs'
import { navigate } from '../../actions/routes'
import {
  OpenDialog,
  SelectApplicationsArray,
  RejectApplicationAction,
  Navigate,
  CloseDialog
} from '../../actions/types'
import Container from '../../components/Container'
import { objectNotEmpty } from '../../libs/objects'
import { selectApartmentById } from '../../selectors/apartments'
import {
  selectAvailabilitiesByApartment,
  selectAvailabilitiesByApplicationIds
} from '../../selectors/applicantAvailability'
import {
  selectApplicationsByApartmentId,
  getApplicationsGroupedByStatus,
  selectSelectedApplications,
  selectIsApplicationsLoading
} from '../../selectors/applications'
import { selectContentIdFromPathname } from '../../selectors/router'
import { selectShowingsInterfaceByApartmentId } from '../../selectors/showings'
import {
  selectIsAdminUser,
  selectIsMobile,
  selectUserAttributes
} from '../../selectors/users'
import { UserAttributes } from '../../services/auth/types'
import { getCurrentLanguage } from '../../translations/i18n'
import { MuiClasses } from '../../types'
import { Apartment, ApartmentStatus } from '../../types/apartments'
import { ApplicantAvailability } from '../../types/applicantAvailability'
import { Application, ApplicationsByStatus } from '../../types/applications'
import { Showing } from '../../types/showings'
import { EmptyShowingsInterface, StateInterface } from '../../types/states'
import { get, addPopup, getOrCreateConversation } from '../../utils/talkChat'
import { isSuperLikeActive } from '../../utils/applications'
import Suggest from '../Apartment/Stepper/Steps/Suggest'
import ApplicationCard from './ApplicationCard'
import ApplicationsTabs from './ApplicationsTabs'
import { useLocation, useHistory } from 'react-router-dom';
import Api from '../../services/applications'

interface StateProps {
  isMobile?: boolean
  isAdmin: boolean
  applicationsByStatus?: ApplicationsByStatus
  apartment?: Apartment
  userAttributes: any
  selectedApplicationsFromState: string[]
  availabilities?: ApplicantAvailability[]
  existingShowings?: Showing[]
  isApplicationsLoading?: boolean
}
interface DispatchProps {
  openDialog: OpenDialog
  closeDialog: CloseDialog
  selectApplicationsAction: SelectApplicationsArray
  navigateToPath: Navigate
}

interface ApplicationsProps extends WithTranslation {
  classes: MuiClasses
  t: i18n.TFunction
  selectApplicationsAction: SelectApplicationsArray
  rejectApplicationAction: RejectApplicationAction
}

type ComponentProps = ApplicationsProps &
  StateProps &
  DispatchProps &
  WithStyles

const styles = ({ breakpoints, spacing }: Theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'column' as const,
    [breakpoints.down('xs')]: {
      paddingBottom: '45px'
    }
  },
  link: {
    color: 'inherit'
  },
  primaryBtn: {
    backgroundColor: '#94004A',
    '&:hover': {
      backgroundColor: '#670033'
    }
  },
  applications: {
    paddingTop: '1rem',
    justifyContent: 'center' as const
  },
  loadingWrap: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '2rem 0'
  },
  subContainer: {
    position: 'relative' as const,
    padding: '0rem 10rem',
    paddingTop: '2rem',
    [breakpoints.down('md')]: {
      padding: '2rem'
    },
    [breakpoints.down('sm')]: {
      padding: '0.5rem',
      paddingTop: '2rem'
    },
    '& .infoIcon': {
      color: '#000',
      position: 'absolute',
      right: '1rem',
      top: '0.25rem',
      cursor: 'pointer',
      display: 'flex',
      alignItems: 'center',
      gap: '4px',
      '& a': {
        height: '35px',
        display: 'flex',
        alignItems: 'center',
        textDecoration: 'none',
        color: 'inherit'
      },
      '& svg': {
        height: '35px',
        width: '35px',
        color: '#000',
        textDecoration: 'none'
      }
    }
  },
  inviteButton: {
    alignSelf: 'flex-end'
  },
  message: {
    color: '#707070',
    background: '#E8E8E8',
    boxShadow: '0px 3px 6px rgba(0,0,0,0.16)',
    padding: '3rem',
    fontSize: '20px',
    textAlign: 'center' as const,
    width: '55%',
    position: 'absolute' as const,
    zIndex: 1,
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)'
  },
  fabDivTop: {
    position: 'fixed' as const,
    height: '36px',
    bottom: spacing(2),
    right: spacing(3),
    '@media (max-width:1065px)': {
      left: spacing(1),
      right: spacing(1),
      bottom: spacing(9),
      display: 'flex',
      justifyContent: 'center',
      '& button': {
        width: '100%',
        height: 'auto !important',
        padding: '6px 16px'
      }
    }
  },
  applicantsButton: {
    display: 'flex',
    justifyContent: 'center',
    position: 'fixed' as const,
    width: '320px',
    zIndex: 1200,
    [breakpoints.up('sm')]: {
      top: '85px',
      right: getCurrentLanguage() == 'en' ? '142px' : '163px'
    },
    [breakpoints.up('md')]: {
      top: '85px',
      right: getCurrentLanguage() == 'en' ? '145px' : '167px'
    },
    [breakpoints.up('lg')]: {
      top: '85px',
      right: getCurrentLanguage() == 'en' ? '148px' : '170px'
    },
    '@media (max-width:1065px)': {
      width: 'auto',
      maxWidth: '464px',
      left: spacing(1),
      right: spacing(1),
      top: 'auto',
      bottom: spacing(9)
    }
  },
  fabDivLeft: {
    marginRight: '7px',
    [breakpoints.only('xs')]: {
      width: '100%',
      '& button': {
        height: 'auto !important',
        width: '100%',
        padding: '6px 16px'
      }
    }
  },
  fabDivLeftTitle: {
    color: '#C3C6D1',
    fontSize: '14px',
    marginLeft: '8px'
  },
  fab: {
    padding: '0 30px',
    height: '36px !important',
    borderRadius: '4px !important',
    background: '#94004A',
    '&:hover': {
      backgroundColor: '#670033'
    }
  },
  addressTitle: {
    paddingBottom: '15px'
  }
})

const Applications: FC<ComponentProps> = ({
  classes,
  isMobile,
  isAdmin,
  apartment,
  // selectedApplicationsFromState,
  applicationsByStatus,
  availabilities,
  existingShowings,
  openDialog,
  selectApplicationsAction,
  rejectApplicationAction,
  t,
  navigateToPath,
  closeDialog,
  userAttributes,
  isApplicationsLoading
}) => {
  let chatPopup: Talk.Popup
  const [filterState, setFilterState] = useState({
    creditStatusGood: false,
    guarantorPossible: false,
    petsNo: false,
    livelihoodPermanentJob: false,
    lifeSituationWorking: false,
    movingWithAlone: false,
    depositPaymentMoney: false,
    depositPaymentIgglo: false,
    rejected: false,
  })
  const [selectedApplications, setSelectedApplications] = useState<string[]>([])
  const [showFilters, setShowFilters] = useState(false)

  const selectApplication = (id: string) => {
    setSelectedApplications(
      selectedApplications.some((currentId: string) => currentId === id)
        ? selectedApplications.filter((currentId: string) => id !== currentId)
        : [...selectedApplications, id]
    )
  }

  const didRunFromParams = useRef(false)
  const location = useLocation()
  const history = useHistory()

  useEffect(() => {
    if (
      userAttributes?.sub && !isAdmin &&
      (userAttributes.collateralVerified === false || userAttributes.collateralVerified == null)
      // &&
      // apartments.some(
      //   a =>
      //     a.status === "marketing" &&
      //     a.confirmation?.vuokraoviCollateral === true
      // )
    ) {
      history.push(`/users/${userAttributes.sub}/verification`)
    }
  }, [userAttributes, history])

  useEffect(() => {
    if (didRunFromParams.current) return

    const params = new URLSearchParams(location.search)
    const status = params.get('status')
    const code = params.get('code')

    if (status !== 'generateContractOk' || !code) return
    if (!applicationsByStatus) return

    const wantsContractApps = applicationsByStatus.wantsContract || []
    const matched = wantsContractApps.find(app => app.code === code)

    if (!matched || !matched.contract) {
      console.warn('No matching application or contract for code', code)
      return
    }

    didRunFromParams.current = true

    const run = async () => {
      try {
        const contract = matched.contract
        const pdfData2 = await Api.generateContractPDF(contract)
        const pdfData = pdfData2.pdf

        // If Buffer is available in your environment, you can keep your original:
        // const pdfBlob = new Blob([Buffer.from(pdfData, 'base64')], { type: 'application/pdf' })

        // Browser-safe base64 → Uint8Array conversion without Buffer:
        const byteChars = atob(pdfData)
        const byteNums = new Array(byteChars.length)
        for (let i = 0; i < byteChars.length; i++) byteNums[i] = byteChars.charCodeAt(i)
        const pdfBlob = new Blob([new Uint8Array(byteNums)], { type: 'application/pdf' })

        const pdfUrl = URL.createObjectURL(pdfBlob)
        const link = document.createElement('a')
        const fileName = `${t('contractCreator.fileName')}_${contract.apartment.address.replace(/\s+/g, '_')}.pdf`
        link.href = pdfUrl
        link.download = fileName
        link.click()
        const u = new URL(window.location.href)
        u.searchParams.delete('code')

        // replace current URL so the param is gone
        window.history.replaceState(null, '', u.toString())

        // then hard reload the page
        window.location.reload()
        // Redirect to Applications (tab: showingReserved)

        // const message = t('contractCreator.contract.downloadPDFSuccess')
        // toast.info(message, { autoClose: 25000 })
      } catch (error) {
        // const message = t('contractCreator.contract.downloadPDFFailed')
        // toast.info(message, { autoClose: 25000 })
        console.error('Error generating or opening PDF:', error)
      }
    }

    run()
  }, [
    location.search,
    applicationsByStatus,
  ])

  if (!apartment || !applicationsByStatus) {
    return (
      <Fragment>
        <Container className={classes.container}>
          <div className={classes.loadingWrap}>
            <CircularProgress size={48} style={{ color: '#94004A' }} />
          </div>
        </Container>
      </Fragment>
    )
  }

  const {
    created: createdApplications,
    rejected: rejectedApplications,
    accepted: acceptedApplications,
    showingReserved: showingReservedApplications,
    noAvailableTimes: noAvailableTimesApplications,
    wantsContract: wantsContractApplications,
    invitationsSent: invitationsSentApplications,
    tenant: tenantApplications,
  } = applicationsByStatus

  // Removed unused applicants, viewingApplicants, contractApplicants

  // const hasNoAvailableTimesApplications =
  //   noAvailableTimesApplications.length > 0
  const tabsProps = {
    filterState,
    setFilterState,
    t,
    isAdmin
  }

  const commonCardProps = {
    openDialog,
    closeDialog,
    t
  }

  const createdAndRejectedCardProps = {
    ...commonCardProps,
    selectApplication,
    rejectApplicationAction
  }

  const allowInvitations =
    apartment.status === ApartmentStatus.marketing ||
    apartment.status === ApartmentStatus.followUp

  /** todo, allow actions in followUp status */
  const disableApplicationActions =
    apartment.status !== ApartmentStatus.marketing &&
    apartment.status !== ApartmentStatus.followUp

  // New filter logic: default shows all except rejected; optional behavior filters
  const getFilteredApplications = () => {
    let base: Application[] = []
    base = base
      .concat(createdApplications)
      .concat(acceptedApplications)
      .concat(noAvailableTimesApplications)
      .concat(showingReservedApplications)
      .concat(wantsContractApplications)
      .concat(invitationsSentApplications)
      .concat(tenantApplications)

    // When apartment is rented (landlord view), show only tenant
    if (!isAdmin && apartment.status === ApartmentStatus.rented) {
      base = [...tenantApplications]
    }

    // Show rejected by default for admins; others only when explicitly requested
    if (isAdmin || filterState.rejected) {
      base = base.concat(rejectedApplications)
    }

    const {
      creditStatusGood,
      guarantorPossible,
      petsNo,
      livelihoodPermanentJob,
      lifeSituationWorking,
      movingWithAlone,
      depositPaymentMoney,
      depositPaymentIgglo,
    } = filterState

    const anyBehaviorChecked = (
      creditStatusGood ||
      guarantorPossible ||
      petsNo ||
      livelihoodPermanentJob ||
      lifeSituationWorking ||
      movingWithAlone ||
      depositPaymentMoney ||
      depositPaymentIgglo
    )

    if (!anyBehaviorChecked) return base

    return base.filter(app => {
      const d: any = app.data || {}
      if (creditStatusGood && d.creditStatus !== 'good') return false
      if (guarantorPossible && d.guarantorPossible !== 'yes') return false
      if (petsNo && d.pets !== 'no') return false
      if (livelihoodPermanentJob) {
        const lh = d.livelihood
        const has = Array.isArray(lh) ? lh.includes('permanentJob') : lh === 'permanentJob'
        if (!has) return false
      }
      if (lifeSituationWorking && d.lifeSituation !== 'working') return false
      if (movingWithAlone && d.movingWith !== 'alone') return false
      if (depositPaymentMoney || depositPaymentIgglo) {
        const v = d.depositPaymentMethod
        const matchMoney = depositPaymentMoney && v === 'money'
        const matchIgglo = depositPaymentIgglo && v === 'iggloRentalGuarantee'
        if (!(matchMoney || matchIgglo)) return false
      }
      return true
    })
  }

  const sortDesc = (applications: Application[]) =>
    applications.sort((a, b) => {
      const aSuper = isSuperLikeActive(a) ? 1 : 0
      const bSuper = isSuperLikeActive(b) ? 1 : 0
      if (aSuper !== bSuper) {
        return bSuper - aSuper
      }
      return b.createdAt - a.createdAt
    })
  /** handle showing creation for single application */

  /** handle showing creation for multiple applications */
  const openSelectedApplicationsPage = () => {
    initiateApplicantsConversation()
    selectApplicationsAction(selectedApplications)
    navigateToPath(`showings`)
  }

  const initiateApplicantsConversation = async () => {
    const filtered = getFilteredApplications()
    for (const applicationId of selectedApplications) {
      const application = filtered.find(
        (app: Application) => app.applicationId === applicationId
      )
      if (application) await initiateConversation(application)
    }
  }

  const initiateConversation = async (application: Application) => {
    const conversation = await getOrCreateConversation(apartment, application)
    //console.log('application conversation', Object.assign({}, conversation))
    return conversation
  }

  const showChatPopup = async (conversation: any) => {
    const session = await get()
    chatPopup = session.createPopup({
      launcher: 'never',
      showCloseInHeader: true,
      messageField: { enterSendsMessage: false }
    })
    chatPopup.onCustomConversationAction('delete', (event: any) => {
      ;(async () => {
        try {
          await Api.deleteTalkConversation(event.conversation.id)
        } catch (error) {
          console.error('Failed to delete conversation via backend', error)
        }
      })()
    })
    chatPopup.select(conversation)
    chatPopup.mount({ show: true })
    addPopup(chatPopup)
  }

  const chatWithApplicant = async (applicationId: string) => {
    const filtered = getFilteredApplications()
    const application = filtered.find(
      (app: Application) => app.applicationId === applicationId
    )
    if (application) {
      const conversation = await initiateConversation(application)
      await showChatPopup(conversation)
    }
  }

  return (
    <Fragment>
      <Container className={classes.container}>
        <Container className={classes.subContainer}>
          <Typography variant='h5' className={classes.addressTitle}>
            {apartment?.information?.address}
          </Typography>

          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', width: '100%' }}>
            <Typography
              variant='h5'
              gutterBottom
              style={{
                marginRight: '1rem',
                fontSize: '1.3rem',
                fontWeight: 'normal',
                flex: 1,
                minWidth: 0
              }}
            >
              {`${t('apartments.status.newApplicants')} (${getFilteredApplications().length})`}
            </Typography>

            <Typography variant='body1' color='primary'>
              <Link
                href='#'
                onClick={() => setShowFilters(!showFilters)}
              >
                {`${t('applications.filters')} ${showFilters ? '▲' : '▼'}`}
              </Link>
            </Typography>
          </div>
          {showFilters && (<ApplicationsTabs {...tabsProps} />)}

          <Grid
            container
            className={classes.applications}
            alignItems={isMobile ? 'center' : 'flex-start'}
            justifyContent={isMobile ? 'center' : 'flex-start'}
            spacing={isMobile ? 0 : 2}
          >
            {sortDesc(getFilteredApplications()).map((application) => (
              <Grid item key={application.applicationId} lg={4} md={4} sm={6} xs={12}>
                <ApplicationCard
                  key={application.applicationId}
                  application={application}
                  apartment={apartment}
                  userAttributes={userAttributes}
                  listCase={application?.status}
                  disableActions={disableApplicationActions}
                  chatWithApplicant={chatWithApplicant}
                  allowInvitations
                  isAdmin={isAdmin}
                  isSelected={selectedApplications.some(
                    (applicantId: string) =>
                      applicantId === application.applicationId
                  )}
                  {...createdAndRejectedCardProps}
                  availabilities={
                    availabilities
                      ? selectAvailabilitiesByApplicationIds(availabilities, [
                        application.applicationId
                      ])
                      : undefined
                  }
                  showings={existingShowings?.filter(
                    (showing) =>
                      showing.applicationIds?.includes(
                        application.applicationId
                      ) ||
                      showing.invitedApplicationIds?.includes(
                        application.applicationId
                      )
                  )}
                />
              </Grid>
            ))}
            {getFilteredApplications().length === 0 && (
              <Typography variant='body1' gutterBottom>
                <Suggest
                  content={<div>
                    {t('application.noApplicantsReceived.part1')}{" "}
                    <a href={t('application.noApplicantsReceived.linkUrl')} style={{ color: "#94004A" }} target="_blank">
                      {t('application.noApplicantsReceived.linkText')}
                    </a>
                    {t('application.noApplicantsReceived.part2')}
                  </div>}
                  //content={t('application.noApplicantsReceived')}
                  containerMaxWidth='850px'
                  contentMaxWidth='650px'
                />
              </Typography>
            )}
          </Grid>
          {getFilteredApplications().length > 0 && (
            <Suggest
              content={t('applications.hints.received')}
              containerMaxWidth='850px'
              contentMaxWidth='650px'
            />
          )}
        </Container>
        {selectedApplications.length > 0 && (
          <div className={classes.applicantsButton}>
            <span className={classes.fabDivTop}>
              <Fab
                color='primary'
                variant='extended'
                disabled={!allowInvitations}
                className={classes.fab}
                onClick={openSelectedApplicationsPage}
              >
                {allowInvitations
                  ? `${t('application.inviteApplicants')} (${selectedApplications.length
                  })`
                  : t('application.inviteDisabled')}
              </Fab>
            </span>
          </div>
        )}
      </Container>
    </Fragment>
  )
}

const mapStateToProps = (state: StateInterface) => {
  const apartmentId = selectContentIdFromPathname(state)

  const showingsInterface = apartmentId
    ? selectShowingsInterfaceByApartmentId(apartmentId)(state)
    : EmptyShowingsInterface

  const stateUserAttributes = selectUserAttributes(state)

  return {
    isMobile: selectIsMobile(state),
    isAdmin: selectIsAdminUser(state),
    apartment: apartmentId
      ? selectApartmentById(apartmentId)(state)
      : undefined,
    userAttributes: objectNotEmpty<UserAttributes>(stateUserAttributes)
      ? stateUserAttributes
      : undefined,
    selectedApplicationsFromState: selectSelectedApplications(state),
    existingShowings: showingsInterface.showings,
    applicationsByStatus: apartmentId
      ? getApplicationsGroupedByStatus(
        selectApplicationsByApartmentId(apartmentId)(state)
      )
      : undefined,
    availabilities: apartmentId
      ? selectAvailabilitiesByApartment(apartmentId)(state)
      : undefined,
    isApplicationsLoading: selectIsApplicationsLoading(state)
  }
}
const mapDispatchToProps = (dispatch: Dispatch) => ({
  openDialog: (id: string) => dispatch(openDialog(id)),
  closeDialog: (id: string) => dispatch(closeDialog(id)),
  selectApplicationsAction: (applicationIdArray: string[]) =>
    dispatch(selectApplications(applicationIdArray)),
  rejectApplicationAction: (apartmentId: string, applicationId: string) =>
    dispatch(rejectApplication(apartmentId, applicationId)),
  navigateToPath: (path: string) => dispatch(navigate(path))
})

export default connect<
  StateProps,
  DispatchProps,
  ApplicationsProps,
  StateInterface
>(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(withStyles(styles)(Applications)))
